import allowed from '@/core/constants/allowed-roles.constant'

const index = [
  {
    path: '/leadership-capabilities',
    meta: {
      layout: 'home',
      module: 'safety-observation',
      requiresAuth: true,
      allowedRoles: [...allowed.safety_observation.roles],
    },
    children: [
      {
        path: 'safety-observation',
        name: 'Safety Observation',
        component: () =>
          import(
            '@/modules/safety-observation/containers/safety-observation-root.container.vue'
          ),
        children: [
          {
            path: '',
            name: 'Safety Observation Home',
            component: () =>
              import(
                '@/modules/safety-observation/containers/safety-observation.container.vue'
              ),
          },
          {
            path: 'safe-report',
            name: 'Safe Report',
            component: () =>
              import(
                '@/modules/safety-observation/containers/safe-report.container.vue'
              ),
          },
          {
            path: 'safe-report/:id',
            name: 'Safe Report Id',
            component: () =>
              import(
                '@/modules/safety-observation/containers/safe-report.container.vue'
              ),
          },
          {
            path: 'unsafe-report',
            name: 'Unsafe Report',
            component: () =>
              import(
                '@/modules/safety-observation/containers/unsafe-report.container.vue'
              ),
          },
          {
            path: 'unsafe-report/:id',
            name: 'Unsafe Report Id',
            component: () =>
              import(
                '@/modules/safety-observation/containers/unsafe-report.container.vue'
              ),
          },
          {
            path: 'settings',
            name: 'safety-settings',
            meta: {
              allowedRoles: [...allowed.safety_observation.settings],
            },
            component: () =>
              import(
                '@/modules/safety-observation/containers/safety-module-settings.container.vue'
              ),
          },
        ],
      },
    ],
  },
]

export default index
